
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("lq4sa"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("lq4sa", function(module, exports) {

let $f97f7affcd08efa7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f97f7affcd08efa7$var$load("5wVuh"),
    $f97f7affcd08efa7$var$load("4NznW"),
    $f97f7affcd08efa7$var$load("1F7LX"),
    $f97f7affcd08efa7$var$load("jZLnv"),
    $f97f7affcd08efa7$var$load("6edij"),
    $f97f7affcd08efa7$var$load("gknbb"),
    $f97f7affcd08efa7$var$load("6iz6l"),
    $f97f7affcd08efa7$var$load("4SCW2"),
    $f97f7affcd08efa7$var$load("36QeB"),
    $f97f7affcd08efa7$var$load("9q75n"),
    $f97f7affcd08efa7$var$load("iYHbd"),
    $f97f7affcd08efa7$var$load("cHb2G"),
    $f97f7affcd08efa7$var$load("3q2Ng"),
    $f97f7affcd08efa7$var$load("jRpDi"),
    $f97f7affcd08efa7$var$load("hnGEQ"),
    $f97f7affcd08efa7$var$load("3GuOt"),
    $f97f7affcd08efa7$var$load("jbM5v"),
    $f97f7affcd08efa7$var$load("dek7I"),
    $f97f7affcd08efa7$var$load("dYtBN"),
    $f97f7affcd08efa7$var$load("kNV5Y"),
    $f97f7affcd08efa7$var$load("6SWFK"),
    $f97f7affcd08efa7$var$load("9aQIt"),
    $f97f7affcd08efa7$var$load("5zapo"),
    $f97f7affcd08efa7$var$load("3MYQs"),
    $f97f7affcd08efa7$var$load("XZauT"),
    $f97f7affcd08efa7$var$load("4S1SF"),
    $f97f7affcd08efa7$var$load("jiFtb"),
    $f97f7affcd08efa7$var$load("lm9Lt"),
    $f97f7affcd08efa7$var$load("9atVd"),
    $f97f7affcd08efa7$var$load("9wPDc"),
    $f97f7affcd08efa7$var$load("1MWOL"),
    $f97f7affcd08efa7$var$load("6fQco"),
    $f97f7affcd08efa7$var$load("aOY32"),
    $f97f7affcd08efa7$var$load("7jSfd"),
    $f97f7affcd08efa7$var$load("4HZlX"),
    $f97f7affcd08efa7$var$load("kDqHr"),
    $f97f7affcd08efa7$var$load("6wr18"),
    $f97f7affcd08efa7$var$load("gT8XU"),
    $f97f7affcd08efa7$var$load("53AGa"),
    $f97f7affcd08efa7$var$load("8bhm4"),
    $f97f7affcd08efa7$var$load("ffEVr"),
    $f97f7affcd08efa7$var$load("7EorR"),
    $f97f7affcd08efa7$var$load("8k9aB"),
    $f97f7affcd08efa7$var$load("fLwVm"),
    $f97f7affcd08efa7$var$load("kuFG2"),
    $f97f7affcd08efa7$var$load("hhss7"),
    $f97f7affcd08efa7$var$load("Wowvf"),
    $f97f7affcd08efa7$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("cqc9f"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("cqc9f", function(module, exports) {

let $90b15618f435f76f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90b15618f435f76f$var$load("6wr18"),
    $90b15618f435f76f$var$load("cHb2G"),
    $90b15618f435f76f$var$load("53AGa"),
    $90b15618f435f76f$var$load("8bhm4"),
    $90b15618f435f76f$var$load("ffEVr"),
    $90b15618f435f76f$var$load("cX4Bp"),
    $90b15618f435f76f$var$load("dawn8"),
    $90b15618f435f76f$var$load("hhss7"),
    $90b15618f435f76f$var$load("aQh37"),
    $90b15618f435f76f$var$load("bJVDE"),
    $90b15618f435f76f$var$load("8k9aB"),
    $90b15618f435f76f$var$load("fLwVm"),
    $90b15618f435f76f$var$load("kuFG2"),
    $90b15618f435f76f$var$load("1F7LX"),
    $90b15618f435f76f$var$load("3QXpo"),
    $90b15618f435f76f$var$load("h3ABO"),
    $90b15618f435f76f$var$load("kC80R"),
    $90b15618f435f76f$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("75tqi"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("75tqi", function(module, exports) {

let $528fd2e123ea429d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $528fd2e123ea429d$var$load("582xP"),
    $528fd2e123ea429d$var$load("lRfiO"),
    $528fd2e123ea429d$var$load("fuks3"),
    $528fd2e123ea429d$var$load("b9CA3"),
    $528fd2e123ea429d$var$load("2YffH"),
    $528fd2e123ea429d$var$load("lUDr0"),
    $528fd2e123ea429d$var$load("8dwgS"),
    $528fd2e123ea429d$var$load("9XOeB"),
    $528fd2e123ea429d$var$load("xu7ej"),
    $528fd2e123ea429d$var$load("iQ4FP"),
    $528fd2e123ea429d$var$load("71gca"),
    $528fd2e123ea429d$var$load("dV37I"),
    $528fd2e123ea429d$var$load("82Jpo"),
    $528fd2e123ea429d$var$load("eXKRO"),
    $528fd2e123ea429d$var$load("im1VN"),
    $528fd2e123ea429d$var$load("bTT9C"),
    $528fd2e123ea429d$var$load("czOM6"),
    $528fd2e123ea429d$var$load("5yluq"),
    $528fd2e123ea429d$var$load("2tcSk"),
    $528fd2e123ea429d$var$load("j8WjL"),
    $528fd2e123ea429d$var$load("8auEH"),
    $528fd2e123ea429d$var$load("jAeEl"),
    $528fd2e123ea429d$var$load("lKs3T"),
    $528fd2e123ea429d$var$load("9anPW"),
    $528fd2e123ea429d$var$load("3EXzu"),
    $528fd2e123ea429d$var$load("b2FtX"),
    $528fd2e123ea429d$var$load("gnDXu"),
    $528fd2e123ea429d$var$load("dl2qY"),
    $528fd2e123ea429d$var$load("kL5FA"),
    $528fd2e123ea429d$var$load("6iz6l"),
    $528fd2e123ea429d$var$load("4SCW2"),
    $528fd2e123ea429d$var$load("9q75n"),
    $528fd2e123ea429d$var$load("iYHbd"),
    $528fd2e123ea429d$var$load("3q2Ng"),
    $528fd2e123ea429d$var$load("jRpDi"),
    $528fd2e123ea429d$var$load("5wVuh"),
    $528fd2e123ea429d$var$load("4NznW"),
    $528fd2e123ea429d$var$load("3Kmdt"),
    $528fd2e123ea429d$var$load("kKX58"),
    $528fd2e123ea429d$var$load("c0JsV"),
    $528fd2e123ea429d$var$load("h3ABO"),
    $528fd2e123ea429d$var$load("gYQRR"),
    $528fd2e123ea429d$var$load("4XdkL"),
    $528fd2e123ea429d$var$load("4eock"),
    $528fd2e123ea429d$var$load("8k9aB"),
    $528fd2e123ea429d$var$load("fLwVm"),
    $528fd2e123ea429d$var$load("6wr18"),
    $528fd2e123ea429d$var$load("1JF7a"),
    $528fd2e123ea429d$var$load("Wowvf"),
    $528fd2e123ea429d$var$load("cX4Bp"),
    $528fd2e123ea429d$var$load("dawn8"),
    $528fd2e123ea429d$var$load("ffEVr"),
    $528fd2e123ea429d$var$load("hhss7"),
    $528fd2e123ea429d$var$load("aQh37"),
    $528fd2e123ea429d$var$load("bJVDE"),
    $528fd2e123ea429d$var$load("1F7LX"),
    $528fd2e123ea429d$var$load("3QXpo"),
    $528fd2e123ea429d$var$load("jnVKv"),
    $528fd2e123ea429d$var$load("7EorR"),
    $528fd2e123ea429d$var$load("bgHzk"),
    $528fd2e123ea429d$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.e95181a9.js.map
